import { InputState } from '@kubit/web-ui-components/input/types';
import { InputCurrencyConverterVariantType } from '../../../../../../components/inputCurrencyConverter/types/inputCurrencyConverterVariantType';
import { commonErrorStyles, commonStyles, defaultEmptyFontCommonStyles, disabledFilledCommonStyles, } from '../commonStyles';
export const getRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [InputCurrencyConverterVariantType.REGULAR]: {
            [InputState.EMPTY]: {
                ...commonStyles(FOUNDATIONS, FONT, {}),
                ...defaultEmptyFontCommonStyles(FOUNDATIONS, FONT),
            },
            [InputState.FILLED]: {
                ...commonStyles(FOUNDATIONS, FONT, {
                    inputContainer: { border: FOUNDATIONS.color_neutral_border_50 },
                }),
            },
            [InputState.ACTIVE]: {
                ...commonStyles(FOUNDATIONS, FONT, {
                    inputContainer: {
                        border_color: 'transparent',
                        outline: `${FOUNDATIONS.color_comp_forms_input_active_border} solid ${FOUNDATIONS.border_100}`,
                    },
                }),
            },
            [InputState.DISABLED_EMPTY]: {
                ...commonStyles(FOUNDATIONS, FONT, {
                    inputContainer: {
                        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                        border: FOUNDATIONS.color_accent_disabled_border_100,
                        cursor: 'default',
                    },
                    inputTypography: {
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                    affix: {
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                    placeholder: {
                        color: FOUNDATIONS.color_accent_disabled_font_100,
                    },
                }),
            },
            [InputState.DISABLED_FILLED]: {
                ...disabledFilledCommonStyles(FOUNDATIONS, FONT),
            },
            [InputState.DISABLED_FILLED_WITH_INFO]: {
                ...disabledFilledCommonStyles(FOUNDATIONS, FONT),
            },
            [InputState.ERROR_EMPTY]: {
                ...commonStyles(FOUNDATIONS, FONT, {
                    inputContainer: {
                        background_color: FOUNDATIONS.color_comp_forms_input_error_empty_bg,
                        border_color: 'transparent',
                        outline: `${FOUNDATIONS.color_feedback_error_border_50} solid ${FOUNDATIONS.border_100}`,
                        outline_offset: 'unset',
                        box_shadow: 'none',
                    },
                }),
                ...defaultEmptyFontCommonStyles(FOUNDATIONS, FONT),
                ...commonErrorStyles(FOUNDATIONS, FONT),
            },
            [InputState.ERROR_FILLED]: {
                ...commonStyles(FOUNDATIONS, FONT, {
                    inputContainer: {
                        background_color: FOUNDATIONS.color_comp_forms_input_error_filled_bg,
                        border_color: 'transparent',
                        outline: `${FOUNDATIONS.color_feedback_error_border_50} solid ${FOUNDATIONS.border_100}`,
                        outline_offset: 'unset',
                        box_shadow: 'none',
                    },
                }),
                ...commonErrorStyles(FOUNDATIONS, FONT),
            },
            [InputState.ERROR_ACTIVE]: {
                ...commonStyles(FOUNDATIONS, FONT, {
                    inputContainer: {
                        background_color: FOUNDATIONS.color_feedback_error_bg_200,
                        border_color: 'transparent',
                        outline: `${FOUNDATIONS.color_feedback_error_border_50} solid ${FOUNDATIONS.border_100}`,
                        outline_offset: 'unset',
                        box_shadow: 'none',
                    },
                }),
                ...commonErrorStyles(FOUNDATIONS, FONT),
            },
            [InputState.ERROR_FILLED_WITH_INFO]: {
                ...commonStyles(FOUNDATIONS, FONT, {
                    inputContainer: {
                        background_color: FOUNDATIONS.color_feedback_error_bg_200,
                        border_color: 'transparent',
                        outline: `${FOUNDATIONS.color_feedback_error_border_50} solid ${FOUNDATIONS.border_100}`,
                        outline_offset: 'unset',
                        box_shadow: 'none',
                    },
                }),
                ...commonErrorStyles(FOUNDATIONS, FONT),
            },
        },
    };
};
//# sourceMappingURL=regular.js.map